/**
 * Used to define the various states and types of automation executions: workflows, instructions
 */
export enum ExecutionStatusEnum {
  Waiting = 'waiting',
  UserInput = 'awaiting user input',
  InProgress = 'in progress',
  Cancelled = 'cancelled',
  Success = 'success',
  Failed = 'failed'
}

export enum InstructionType {
  AiPrompt = 'AI Prompt',
  Agent = 'Agent',
  FileUpload = 'File Upload',
  CollectInformation = 'Collect Information'
}
